export default "__VITE_ASSET__CHT5xdeO__"